import type { RouteLocationNormalized, RouteRecordRaw } from 'vue-router';
import { useTerminalContextStore } from '../stores/terminalContextStore';
import { useAuthStore } from '@/modules/auth/stores/authStore';

function requireSelectedWarehouse() {
  const contextStore = useTerminalContextStore();
  return contextStore.selectedWarehouseId == null ? { name: 'home' } : true;
}

function requireInventoryAccess() {
  const contextStore = useTerminalContextStore();
  const authStore = useAuthStore();
  if (contextStore.selectedWarehouseId == null) return { name: 'home' };
  if (contextStore.selectedWarehouse?.type === 'Produktionslager' && !authStore.isWmsAdmin) return { name: 'home' };
  return true;
}

function requireNonProductionWarehouse() {
  const contextStore = useTerminalContextStore();
  if (contextStore.selectedWarehouseId == null || contextStore.selectedWarehouse?.type === 'Produktionslager') return { name: 'home' };
  return true;
}

function requireMoveAccess(to: RouteLocationNormalized) {
  const contextStore = useTerminalContextStore();
  if (contextStore.selectedWarehouseId == null) return { name: 'home' };

  const entry = to.query.entry;
  const isProductionWarehouse = contextStore.selectedWarehouse?.type === 'Produktionslager';
  if (isProductionWarehouse && (entry === 'provision' || entry === 'relocate')) return { name: 'home' };

  return true;
}

export const wmsTerminalRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: () => import('../pages/_layout/WmsTerminalLayout.vue'),
    // meta: { scope: 'wms-terminal', title: 'WMS Terminal' },
    children: [
      { path: '', name: 'home', component: () => import('../pages/HomeView.vue') },
      {
        path: 'einlagern',
        name: 'wms.terminal-etiketten.einlagern',
        component: () => import('../pages/EinlagernView.vue'),
        beforeEnter: requireNonProductionWarehouse,
      },
      {
        path: 'auslagern',
        name: 'wms.terminal-etiketten.auslagern',
        component: () => import('../pages/AuslagernView.vue'),
        beforeEnter: requireSelectedWarehouse,
      },
      {
        path: 'umlagern',
        name: 'wms.terminal-etiketten.umlagern',
        component: () => import('../pages/UmlagernView.vue'),
        beforeEnter: requireMoveAccess,
      },
      {
        path: 'inventur',
        name: 'wms.terminal-etiketten.inventur',
        component: () => import('../pages/InventurView.vue'),
        beforeEnter: requireInventoryAccess,
      },
      {
        path: 'bestand',
        name: 'wms.terminal-etiketten.bestand',
        component: () => import('../pages/BestandAnzeigenView.vue'),
        beforeEnter: requireSelectedWarehouse,
      },
    ],
  },
];
